export default __webpack_public_path__ + "static/media/ps_04.f0227f62.png";